import { render, staticRenderFns } from "./VesselMonitoringBays.vue?vue&type=template&id=774f3019"
import script from "./VesselMonitoringBays.vue?vue&type=script&lang=ts"
export * from "./VesselMonitoringBays.vue?vue&type=script&lang=ts"
import style0 from "./VesselMonitoringBays.vue?vue&type=style&index=0&id=774f3019&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports